<script>
	export let title;
	export let items;
</script>

<div class="dashboard-item-container py-3 px-4">
	<div class="dashboard-item-title">
		<span>
			{title}
		</span>
	</div>
	<div class="d-flex">
		{#each items as item}
			<div class="dashboard-item-item">
				<div class="dashboard-item-num ml-3">
					<span class="dashboard-item-subtitle">
						{item.num}
					</span>
				</div>
				<div>
					<span>
						{item.subtitle}
					</span>
				</div>
			</div>
		{/each}
	</div>
</div>
